import React from "react";
import { useTranslation } from "react-i18next";
export const STAGES = {
  Error: -1,
  Loading: 0,
  Activate: 1,
  Spinner: 2,
  EnterPin: 3,
  SkipPin: 4,
  Done: 5,
};

const Submit = ({ stage, register }) => {
  const { t } = useTranslation();
  switch (stage) {
    case STAGES.Activate:
      return (
        <button className="submit-button" type="submit" id="signupSubmit" value="submit" data-cy="submit">
          {t("submit.send_activation_pin")}
        </button>
      );
    case STAGES.Spinner:
      return <div className="loader">{t("common.loading")}</div>;
    case STAGES.EnterPin:
      return (
        <>
          <label className="label" htmlFor="pin">
            {t("submit.enter_pin_label")}
          </label>
          <input type="text" id="pin" name="pin" disabled={stage !== STAGES.EnterPin} {...register("pin", { required: true })} />
          <button className="submit-button" type="submit" id="signupSubmit" value="submit" data-cy="submit">
            {t("submit.submit")}
          </button>
        </>
      );
    case STAGES.SkipPin:
      return (
        <button className="submit-button" type="submit" id="signupSubmit" value="submit" data-cy="submit">
          {t("submit.submit")}
        </button>
      );
    default:
      return <div className="loader">{t("common.loading")}</div>;
  }
};

export default Submit;
